<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells position="between">
        <app-cells :indent="false">
          <h1 class="title">
            {{ employee.first_name }} {{ employee.last_name }}
          </h1>
        </app-cells>
        <a
          v-if="is_superuser"
          :href="`${admin_url}employees/employee/${$route.params.id}/`"
          target="_blank"
          class="btn btn--blue"
        >
          Django
        </a>
      </app-cells>
      <app-tabs :tabs="tabs" />
      <transition name="fade" mode="out-in">
        <router-view :employee="employee" @update="fetchData" />
      </transition>
    </template>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import { getEmployee, patchEmloyee } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'EmployeeLayout',
  components: { AppTabs },
  data() {
    return {
      is_loaded: false,
      tabs: [
        { name: 'employees-profile', label: 'Profile' },
        { name: 'employees-documents', label: 'Documents' },
        { name: 'employees-contracts-salaries', label: 'Contracts & Salaries' },
        { name: 'employees-employee-leaves', label: 'Leaves' },
        { name: 'employees-other', label: 'Other' },
        { name: 'employees-biometry', label: 'Biometry' },
        { name: 'employees-calculation', label: 'Calculation' },
        { name: 'employees-comments', label: 'Comments' },
        { name: 'employees-utt', label: 'UTT' },
      ],
      employee: {},
      admin_url: process.env.VUE_APP_ADMIN_URL,
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    is_superuser() {
      return this.$store.state.userData.is_superuser
    },
  },
  methods: {
    fetchData() {
      getEmployee(this.$route.params.id).then(res => {
        this.employee = res.data
        this.is_loaded = true
      })
    }
  }
}
</script>
